import { AppState } from 'reducers';

export const isGlobalError = (state: AppState) => state.error.errorType;
